import { useState } from 'react';
import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store';
import { cn } from '@shared/utils';
import type { UserWithPaymentInfo } from '@shared/api';
import { UserItemHead } from './userItemHead';
import { UserContacts } from './userContacts';
import { UserLongInfo } from './userLongInfo';
import { ShortInfo } from './shortInfo';

export interface UserProps {
  className?: string;
  user: UserWithPaymentInfo;
}

export const User = (props: UserProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const [showUserLongInfo, setShowUserLongInfo] = useState<boolean>(false);

  return (
    <div
      className={cn(
        'relative min-w-[300px] rounded-lg bg-white transition-shadow duration-200 dark:bg-soft-black',
        profileFeatureStore.data?.userManagement?.viewUserProfileDetails && 'hover:shadow-lg dark:hover:shadow-lg-dark',
        props.className,
      )}
    >
      <div>
        <UserItemHead open={showUserLongInfo} setOpen={() => setShowUserLongInfo((prev) => !prev)} user={props.user} />
        {showUserLongInfo ? (
          <div className='no-scrollbar z-50 max-h-[300px] w-full overflow-auto rounded-b-lg bg-white dark:bg-soft-black'>
            <UserContacts user={props.user} />
            <UserLongInfo open={showUserLongInfo} user={props.user} accounts={props.user.accounts} cards={props.user.cards} />
          </div>
        ) : (
          <ShortInfo type={props.user.userType} locked={props.user.locked} cards={props.user.cards.length} accounts={props.user.accounts.length} />
        )}
      </div>
    </div>
  );
};
